<template>
  <b-modal
    ref="modalRef"
    title="Termos e Condições - Programa ecash"
    centered
    no-close-on-backdrop
    no-close-on-esc
    :ok-title="$t('Aceitar')"
    :cancel-title="$t('Recusar')"
    :ok-disabled="loading || termsHtml === 'Nenhum termo disponível'"
    dialog-class="reward-terms-modal"
    @ok="onAccept"
    @cancel="onReject"
  >
    <div class="terms-container">
      <div
        v-if="loading"
        class="text-center py-5"
      >
        <b-spinner
          label="Carregando termos..."
          type="border"
          variant="primary"
        />
      </div>
      <div
        v-else
        class="terms-content"
      >
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="termsHtml" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BSpinner } from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  components: {
    BModal,
    BSpinner,
  },

  data() {
    return {
      loading: false,
      termsHtml: '',
    }
  },

  methods: {
    ...mapActions('reward', ['getRewardConfiguration']),
    async show() {
      try {
        this.loading = true
        this.$refs.modalRef.show()
        const data = await this.getRewardConfiguration()
        this.termsHtml = data.termsAndConditions || 'Nenhum termo disponível'
      } catch (error) {
        console.error('Erro ao carregar termos:', error)
        this.termsHtml = 'Erro ao carregar os termos. Por favor, tente novamente.'
        this.$refs.modalRef.show()
      } finally {
        this.loading = false
      }
    },

    async onAccept() {
      try {
        this.loading = true
        // Notificar o componente pai que os termos foram aceitos
        this.$emit('accept')
        this.$refs.modalRef.hide()
      } catch (error) {
        console.error('Erro ao aceitar termos:', error)
        throw error
      } finally {
        this.loading = false
      }
    },

    onReject() {
      this.$emit('reject')
      this.$refs.modalRef.hide()
    },
  },
}
</script>

<style lang="scss" scoped>
.terms-container {
  max-height: 60vh;
  overflow-y: auto;
}

:global(.reward-terms-modal) {
  width: 80vw !important;
}

:global(.reward-terms-modal .modal-content) {
  max-height: 70vh !important;
  display: flex;
  flex-direction: column;
}

:global(.reward-terms-modal .modal-body) {
  max-height: calc(70vh - 150px);
  overflow-y: auto;
}

.terms-content {
  font-size: 0.95rem;
  line-height: 1.6;

  :deep(h1),
  :deep(h2),
  :deep(h3) {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }

  :deep(p) {
    margin-bottom: 0.75rem;
  }

  :deep(ul),
  :deep(ol) {
    margin-left: 1.5rem;
    margin-bottom: 0.75rem;
  }

  :deep(li) {
    margin-bottom: 0.25rem;
  }
}
</style>
